import {Backdrop} from "@mui/material";
import {useEffect, useState} from "react";
import useEventDispatcher from "../../../../../use/useEventDispatcher";
import {useParams} from "react-router";

export default function () {
    const {token} = useParams();
    const eventDispatcher = useEventDispatcher();
    const [lock, setLock] = useState(false);

    useEffect(() => {
        eventDispatcher.subscribe("lock-interact", handleLock);
        eventDispatcher.subscribe("unlock-interact", handleUnlock);

        return () => {
            eventDispatcher.unsubscribe("lock-interact", handleLock);
            eventDispatcher.unsubscribe("unlock-interact", handleUnlock);
        }
    }, []);

    const handleLock = () => setLock(true);
    const handleUnlock = () => setLock(false);

    if (!lock || token !== "demo") return null;

    return (
        <Backdrop
            sx={(theme) => ({color: '#fff', zIndex: theme.zIndex.drawer + 1})}
            open={true}
            slotProps={{
                "data-test": "lock-interact"
            }}
        >
        </Backdrop>
    )
}